<template>
  <NoResultsBase
    :header="t('noItemsFoundHeader')"
    :description="t('noItemsFoundWithFilter')"
    icon="arrow_right"
  />
</template>

<script setup lang="ts">
import { useLocalizationStore } from '@/stores/localization.ts'
import NoResultsBase from '@/components/NoResultsBase.vue'

const { t } = useLocalizationStore()
</script>
